import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { bodySmall, caption, poppinsRegularFont, poppinsSemiBoldFont } from '@/styles/typography';
import { CSSProperties } from 'react';
import styled from 'styled-components';

type TextAlignType = CSSProperties['textAlign'];

export const TableNewWrapper = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  overflow: hidden;
`;

export const TableBodyNew = styled.tbody``;

export const TableHeadNewWrapper = styled.thead`
  background-color: ${COLORS.white};
  width: 100%;
  color: ${COLORS.black};
`;

export const TableCellNew = styled.td<{ width?: string; textAlign?: TextAlignType }>`
  padding: 14px 24px;
  width: ${({ width }) => (width ? width : 'auto')};
  color: ${COLORS.grey[850]};
  border-bottom: 1px solid ${COLORS.grey[300]};
  ${poppinsRegularFont};
  ${bodySmall};
  overflow-wrap: anywhere;

  ${({ textAlign }) =>
    textAlign &&
    `
      text-align: ${textAlign};
    `};
`;

export const TableRowNew = styled.tr<{ isClickableRow?: boolean }>`
  cursor: ${({ isClickableRow }) => isClickableRow && 'pointer'};

  &:last-child {
    border-bottom: none;

    ${TableCellNew} {
      border-bottom: none;
    }
    }
  }

  &:hover {
    background-color: ${({ isClickableRow }) => isClickableRow && COLORS.grey[200]};
  }
`;

export const TableHeaderCellIcon = styled.div`
  ${flex({ alignItems: 'center', flexDirection: 'column' })};
`;

export const TableHeadCellWrapper = styled.th<{
  width: string;
  hasSort: boolean;
  textAlign: TextAlignType;
}>`
  padding: 14px 24px;
  width: ${({ width }) => (width ? width : 'auto')};
  ${poppinsSemiBoldFont};
  ${caption};
  letter-spacing: 0.24px;
  vertical-align: top;
  line-height: 20px;
  text-align: ${({ textAlign }) => textAlign};
  font-weight: normal;
  border-bottom: 1px solid ${COLORS.grey[400]};

  ${({ hasSort }) =>
    hasSort && {
      cursor: 'pointer',
    }};
`;

export const TableNewFooter = styled.div`
  padding: 14px 24px 14px;
  border-top: 1px solid ${COLORS.grey[300]};
`;

// TODO: 29.5.1 maybe new loader someday?
// const rotation = keyframes`
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//   }
// `;

// export const TableNewLoader = styled.div`
//   width: 40px;
//   height: 40px;
//   border: 5px solid ${COLORS.grey[600]};
//   border-bottom-color: ${COLORS.green[400]};
//   border-radius: 50%;
//   display: inline-block;
//   box-sizing: border-box;
//   animation: ${rotation} 1s linear infinite;
// }
// `;
